import React, { useEffect, useState } from 'react';
import CustomLineChart from '../../../shared/charts/custom-line-chart/CustomLineChart';
import CustomDualAxesChart from '../../../shared/charts/custom-dual-axes-chart/CustomDualAxesChart';
//temporarily disbale
// import StatisticsCard from "../statistics-card/StatisticsCard";
// import CustomSankeyChart from "../../../shared/charts/custom-sankey-chart/CustomSankeyChart";
import moment from 'moment';
import { Button, Drawer, IconButton, MenuItem, Select } from '@material-ui/core';
import { FormControl } from '@mui/material';
import { statisticsDataKeys } from '../../analytics/Analytics';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import CancelIcon from '@material-ui/icons/Cancel';
import StatisticsItemList from '../statistics-item-list/StatisticsItemList';
import ExportPageAsPDF from '../../../utils/ExportPageAsPDF';
import { ErrorGraphReportMessage } from '../../../constants/AnalyticsConst';
import { getValidValueOrNA } from '../../../utils/commonUtils';

function Arrival(props) {
  const {
    allStatisticsData,
    showAllForReport = false,
    showLoader = () => {},
    setShowAllForReport = () => {},
  } = props;

  const [checkInTrend, setCheckInTrend] = useState([]);
  const [showMoreDetail, setShowMoreDetail] = useState(false);
  const [checkInFlowSankeyDiagram, setCheckInFlowSankeyDiagram] = useState([]);
  const [paymentErrors, setPaymentErrors] = useState([
    {
      name: 'Payment Errors',
      code: 'PE',
    },
    {
      name: 'Key Generation Errors',
      code: 'KG',
    },
    {
      name: 'Digital Check-In Errors',
      code: 'CI',
    },
    {
      name: 'E-Registration Errors',
      code: 'ER',
    },
  ]);

  const [selectedPaymentError, setSelectedPaymentError] = useState(null);
  const [paymentErrorsItems, setPaymentErrorsItems] = useState([]);
  const [paymentErrorsAvgValue, setPaymentErrorsAvgValue] = useState([]);
  const [checkInErrorList, setCheckInErrorList] = useState([]);

  useEffect(() => {
    setSelectedPaymentError('PE');
  }, []);

  useEffect(() => {
    if (allStatisticsData) {
      const statisticValues = {
        checkInTrend: setCheckInTrend,
        checkInFlowSankeyDiagram: setCheckInFlowSankeyDiagram,
      };

      for (const key of Object.keys(statisticValues)) {
        if (allStatisticsData && allStatisticsData[key]) {
          statisticValues[key](allStatisticsData[key]);
        }
      }

      const {
        eRegistrationSuccessErrorTrend = [],
        paymentSuccessErrorTrend = [],
        checkInSuccessErrorTrend = [],
        keyGenerationSuccessErrorTrend = [],
        totalKeyGenerationErrorCount,
        totalKeyGenerationErrorPercentage,
        totalPaymentErrorCount,
        totalPaymentErrorPercentage,
        totalCheckInErrorCount,
        totalCheckInErrorPercentage,
        totalERegistrationErrorCount,
        totalERegistrationErrorPercentage,
      } = allStatisticsData;

      setPaymentErrorsItems({
        KG: keyGenerationSuccessErrorTrend,
        PE: paymentSuccessErrorTrend,
        CI: checkInSuccessErrorTrend,
        ER: eRegistrationSuccessErrorTrend,
      });

      setPaymentErrorsAvgValue({
        KG: [
          {
            name: 'Key Generation Errors',
            value: getValidValueOrNA(totalKeyGenerationErrorCount),
          },
          {
            name: statisticsDataKeys?.errors,
            value: getValidValueOrNA(totalKeyGenerationErrorPercentage),
          },
        ],
        PE: [
          {
            name: 'Payment Errors',
            value: getValidValueOrNA(totalPaymentErrorCount),
          },
          {
            name: statisticsDataKeys?.errors,
            value: getValidValueOrNA(totalPaymentErrorPercentage),
          },
        ],
        CI: [
          {
            name: 'Check-In Errors',
            value: getValidValueOrNA(totalCheckInErrorCount),
          },
          {
            name: statisticsDataKeys?.errors,
            value: getValidValueOrNA(totalCheckInErrorPercentage),
          },
        ],
        ER: [
          {
            name: 'E-Registration Errors',
            value: getValidValueOrNA(totalERegistrationErrorCount),
          },
          {
            name: statisticsDataKeys?.errors,
            value: getValidValueOrNA(totalERegistrationErrorPercentage),
          },
        ],
      });
    }
  }, [allStatisticsData]);

  return (
    <div className='col-12 d-flex flex-wrap gap-3 arrival-container'>
      {/* Temporarily disable */}
      {/* <div className="col-auto col-sm-12 col-md-auto col-lg-auto">
        <StatisticsCard
          currencyCode={allStatisticsData?.currencyCode}
          data={[
            { name: "Conversion", value: allStatisticsData?.arrivalConversion },
            {
              name: "Guests Checked-In",
              value: allStatisticsData?.guestsCheckedIn,
            },
            {
              name: "Revenue",
              value: allStatisticsData?.totalUpsellAmount,
            },
          ]}
        />
      </div> */}
      {checkInTrend?.length > 0 && (
        <div className='col-auto col-sm-12 col-md col-lg box-shadow custom-card mw-100'>
          <div className='h-100 w-100 mw-100 mh-100'>
            <CustomDualAxesChart
              title={'Check-In Trend'}
              xAxis={statisticsDataKeys?.date}
              yAxis1='Conversion'
              yAxis2={statisticsDataKeys?.checkInCount}
              yAxis3={statisticsDataKeys?.preCheckInCount}
              data={checkInTrend?.map((checkIn, index) => {
                return {
                  Date: moment(new Date(checkIn?.date)).format(statisticsDataKeys?.dateFormat),
                  [statisticsDataKeys?.checkInCount]: checkIn?.checkInCount,
                  [statisticsDataKeys?.preCheckInCount]: checkIn?.preCheckInCount,
                  Conversion: checkIn?.arrivalConversion,
                };
              })}
              ChildGraph={[statisticsDataKeys?.checkInCount, statisticsDataKeys?.preCheckInCount]}
            />
          </div>
        </div>
      )}
      {/*Temporally hide  */}
      {/* {checkInFlowSankeyDiagram?.length > 0 && (
        <div className="col-12 box-shadow custom-card mw-100">
          <div className="h-100 w-100 mw-100 mh-100">
            <CustomSankeyChart
              title={"Check-In Flow"}
              data={checkInFlowSankeyDiagram}
              tooltipItems={["source", "target", "value"]}
            />
          </div>
        </div>
      )} */}
      <div className='col-12 box-shadow custom-card mw-100 d-flex flex-wrap'>
        <div className='col'>
          <div className='analytic-header-wrapper title'>
            <span className='analytic-title'>Error Reports</span>
          </div>
          <div className='analytic-breaker' />
          {!showAllForReport && (
            <div className='d-flex justify-content-between p-3'>
              <FormControl variant='standard' sx={{ minWidth: 200 }}>
                <Select
                  labelId='restlist-label'
                  id='rest-select-standard'
                  value={selectedPaymentError}
                  className='dashboard-restaurant-list-dropdown'
                  onChange={(e) => {
                    setSelectedPaymentError(e?.target?.value);
                  }}
                >
                  {paymentErrors?.map((error) => (
                    <MenuItem
                      key={error?.code}
                      value={error?.code}
                      className='analytic-dropdown-list'
                    >
                      {error?.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {checkInErrorList?.length > 0 && (
                <Button
                  variant='outlined'
                  color='secondary'
                  size='medium'
                  onClick={() => {
                    setShowMoreDetail(!showMoreDetail);
                  }}
                >
                  More Details <KeyboardArrowRight className='ms-1' />
                </Button>
              )}
            </div>
          )}
        </div>
        {paymentErrorsItems?.[selectedPaymentError]?.length > 0 ? (
          <div className='col-12 px-2 h-auto w-100 mw-100 mh-100'>
            {showAllForReport
              ? paymentErrors?.map((error, index) => {
                  return (
                    <div key={index} className='d-flex flex-column gap-2'>
                      <span className='ps-2 fw-bold'>{error?.name}</span>
                      <CustomLineChart
                        xAxis={statisticsDataKeys?.date}
                        yAxis={statisticsDataKeys?.errorCount}
                        data={paymentErrorsItems?.[error['code']]?.map((error, index) => {
                          return {
                            Date: moment(new Date(error?.date)).format(
                              statisticsDataKeys?.dateFormat,
                            ),
                            [statisticsDataKeys?.errorCount]: error?.errorCount,
                          };
                        })}
                        includeCard={true}
                        additionalData={paymentErrorsAvgValue?.[error['code']]}
                        tooltipItems={[statisticsDataKeys?.errorCount]}
                      />
                    </div>
                  );
                })
              : paymentErrorsItems?.[selectedPaymentError]?.length > 0 && (
                  <div className='col-12 px-2 h-auto w-100 mw-100 mh-100'>
                    <CustomLineChart
                      xAxis={statisticsDataKeys?.date}
                      yAxis={statisticsDataKeys?.errorCount}
                      data={paymentErrorsItems?.[selectedPaymentError]?.map((error, index) => {
                        return {
                          Date: moment(new Date(error?.date)).format(
                            statisticsDataKeys?.dateFormat,
                          ),
                          [statisticsDataKeys?.errorCount]: error?.errorCount,
                        };
                      })}
                      includeCard={true}
                      additionalData={paymentErrorsAvgValue?.[selectedPaymentError]}
                      tooltipItems={[statisticsDataKeys?.errorCount]}
                    />
                  </div>
                )}
          </div>
        ) : (
          <div className='col-12 px-2 w-100 mw-100 mh-100' align='center'>
            <p>{ErrorGraphReportMessage}</p>
          </div>
        )}
        {checkInErrorList?.length > 0 && (
          <Drawer
            key={'statistics'}
            anchor={'right'}
            open={showMoreDetail}
            onClose={() => {
              setShowMoreDetail(false);
            }}
            className='right-drawer'
          >
            <div className='p-2 position-relative'>
              <div className='col-12'>
                <div className='dismiss-icon d-flex justify-content-end align-items-center'>
                  <div className='col'>
                    <ExportPageAsPDF
                      isTableReport={true}
                      items={checkInErrorList?.map((checkInError, index) => {
                        return {
                          [statisticsDataKeys?.date]: moment(checkInError?.date).format(
                            statisticsDataKeys?.dateFormat,
                          ),
                          [statisticsDataKeys?.reservationId]: checkInError?.reservationId,
                          [statisticsDataKeys?.errorMessage]: checkInError?.errorMessage,
                        };
                      })}
                      contentId={'exportable-content-error-details'}
                      fileName={paymentErrors
                        ?.find((element) => element?.code === selectedPaymentError)
                        ?.name?.replace(' ', '')
                        ?.toLocaleLowerCase()}
                      title={
                        paymentErrors?.find((element) => element?.code === selectedPaymentError)
                          ?.name || 'Detailed Error'
                      }
                      showAllForReport={showAllForReport}
                      setShowAllForReport={setShowAllForReport}
                      showLoader={showLoader}
                      setShowMoreDetail={setShowMoreDetail}
                    />
                  </div>
                  <IconButton onClick={() => setShowMoreDetail(false)}>
                    <CancelIcon />
                  </IconButton>
                </div>
              </div>
              <div id='exportable-content-error-details' className='p-4'>
                <StatisticsItemList
                  title={
                    paymentErrors?.find((element) => element?.code === selectedPaymentError)
                      ?.name || 'Detailed Error Report'
                  }
                  key={2}
                  showErrorsList={true}
                  columnNames={[
                    statisticsDataKeys?.date,
                    statisticsDataKeys?.reservationId,
                    statisticsDataKeys?.error,
                  ]}
                  items={checkInErrorList?.map((checkInError, index) => {
                    return {
                      [statisticsDataKeys?.date]: moment(checkInError?.date).format(
                        statisticsDataKeys?.dateFormat,
                      ),
                      [statisticsDataKeys?.reservationId]: checkInError.reservationId,
                      [statisticsDataKeys?.error]: checkInError.error,
                    };
                  })}
                  showAllForReport={showAllForReport}
                />
              </div>
            </div>
          </Drawer>
        )}
      </div>
    </div>
  );
}

export default Arrival;
